import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Component } from 'react';
import { takeEvery, select, call, put, take, delay, race } from 'redux-saga/effects';
import { isFunction } from 'lodash-es';
import moment from 'moment';
import { action, regHandlers, connect, dispatch, regSaga, store } from '../../../store';
import { login, logoutDirect, retrieveJwt, singleSignOn, fetchSpaMeta, systemLogin } from '../../../apis';
import { socketIdentify } from '../../../apis/socket';
import { refreshSystemToken } from '../../../apis/system';
var defaultLoginProps = {
  error: null,
  password: '',
  pending: false,
  username: ''
};
regHandlers({
  INITIALIZE: function INITIALIZE(state) {
    return state.set('login', defaultLoginProps);
  },
  LOGIN: function LOGIN(state) {
    return state.mergeIn(['login'], {
      error: null,
      pending: true
    });
  },
  LOGOUT: function LOGOUT(state) {
    return state.mergeIn(['session'], {
      loggedIn: false,
      token: null
    }).set('login', defaultLoginProps);
  },
  SET_AUTHENTICATED: function SET_AUTHENTICATED(state, action) {
    return state.mergeIn(['session'], {
      loggedIn: true,
      token: action.payload.token
    }).set('login', defaultLoginProps);
  },
  SET_INITIALIZED: function SET_INITIALIZED(state, action) {
    return state.mergeIn(['session'], {
      csrfToken: action.payload.csrfToken,
      initialized: true,
      loggedIn: !!action.payload.token,
      securityStrategies: action.payload.securityStrategies,
      socket: action.payload.socket,
      spaceSlug: action.payload.spaceSlug,
      token: action.payload.token,
      system: action.payload.system
    }).set('login', defaultLoginProps);
  },
  SET_ERROR: function SET_ERROR(state, action) {
    return state.mergeIn(['login'], {
      error: action.payload,
      password: '',
      pending: false
    });
  },
  SET_PASSWORD: function SET_PASSWORD(state, action) {
    return state.setIn(['login', 'password'], action.payload);
  },
  SET_USERNAME: function SET_USERNAME(state, action) {
    return state.setIn(['login', 'username'], action.payload);
  },
  SINGLE_SIGN_ON: function SINGLE_SIGN_ON(state) {
    return state.mergeIn(['login'], {
      error: null,
      pending: true
    });
  },
  TIMEOUT: function TIMEOUT(state) {
    return state.setIn(['session', 'token'], null);
  }
});
regSaga('WATCH_SYSTEM_AUTHENTICATION', /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var system, pollingActive, _yield$race, authenticated, refresh, _yield$call, error, token;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return take('LOGIN');

        case 2:
          _context.next = 4;
          return select(function (state) {
            return state.getIn(['session', 'system'], false);
          });

        case 4:
          system = _context.sent;
          pollingActive = false;

        case 6:
          if (!system) {
            _context.next = 41;
            break;
          }

          _context.prev = 7;
          _context.next = 10;
          return race({
            authenticated: take('SET_AUTHENTICATED'),
            refresh: delay(180000),
            // 3 minutes.
            isLoggingOut: take('LOGOUT'),
            isTimingOut: take('TIMEOUT')
          });

        case 10:
          _yield$race = _context.sent;
          authenticated = _yield$race.authenticated;
          refresh = _yield$race.refresh;

          if (!authenticated) {
            _context.next = 17;
            break;
          }

          // The authentication event occurred, so now we want to periodically
          // refresh the token.
          pollingActive = true;
          _context.next = 34;
          break;

        case 17:
          if (!(refresh && pollingActive)) {
            _context.next = 33;
            break;
          }

          _context.next = 20;
          return call(refreshSystemToken);

        case 20:
          _yield$call = _context.sent;
          error = _yield$call.error;
          token = _yield$call.token;

          if (!error) {
            _context.next = 28;
            break;
          }

          _context.next = 26;
          return put(action('TIMEOUT'));

        case 26:
          _context.next = 31;
          break;

        case 28:
          _context.next = 30;
          return put(action('SET_AUTHENTICATED', {
            token: token
          }));

        case 30:
          localStorage.setItem(SYSTEM_TOKEN, token);

        case 31:
          _context.next = 34;
          break;

        case 33:
          // Logging out or timing out happened to stop refreshing.
          pollingActive = false;

        case 34:
          _context.next = 39;
          break;

        case 36:
          _context.prev = 36;
          _context.t0 = _context["catch"](7);
          console.error(_context.t0);

        case 39:
          _context.next = 6;
          break;

        case 41:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[7, 36]]);
}));
regSaga(takeEvery('LOGIN', /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
  var payload, system, _yield$select, username, password, _yield$call2, error, systemToken, token;

  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return select(function (state) {
            return state.getIn(['session', 'system']);
          });

        case 4:
          system = _context2.sent;
          _context2.next = 7;
          return select(function (state) {
            return state.get('login');
          });

        case 7:
          _yield$select = _context2.sent;
          username = _yield$select.username;
          password = _yield$select.password;
          _context2.next = 12;
          return call(system ? systemLogin : login, {
            username: username,
            password: password
          });

        case 12:
          _yield$call2 = _context2.sent;
          error = _yield$call2.error;
          systemToken = _yield$call2.token;

          if (!error) {
            _context2.next = 20;
            break;
          }

          _context2.next = 18;
          return put({
            type: 'SET_ERROR',
            payload: error.message
          });

        case 18:
          _context2.next = 31;
          break;

        case 20:
          if (!system) {
            _context2.next = 24;
            break;
          }

          _context2.t0 = systemToken;
          _context2.next = 27;
          break;

        case 24:
          _context2.next = 26;
          return call(retrieveJwt);

        case 26:
          _context2.t0 = _context2.sent;

        case 27:
          token = _context2.t0;

          if (system) {
            localStorage.setItem(SYSTEM_TOKEN, token);
          }

          _context2.next = 31;
          return put({
            type: 'SET_AUTHENTICATED',
            payload: {
              token: token,
              callback: payload
            }
          });

        case 31:
          _context2.next = 36;
          break;

        case 33:
          _context2.prev = 33;
          _context2.t1 = _context2["catch"](1);
          console.error(_context2.t1);

        case 36:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[1, 33]]);
})));
regSaga(takeEvery('SINGLE_SIGN_ON', /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
  var _ref2$payload, callback, spaceSlug, _yield$call3, error, token;

  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref2$payload = _ref2.payload, callback = _ref2$payload.callback, spaceSlug = _ref2$payload.spaceSlug;
          _context3.prev = 1;
          _context3.next = 4;
          return call(singleSignOn, spaceSlug, {
            width: 770,
            height: 750
          });

        case 4:
          _yield$call3 = _context3.sent;
          error = _yield$call3.error;

          if (!error) {
            _context3.next = 11;
            break;
          }

          _context3.next = 9;
          return put({
            type: 'SET_ERROR',
            payload: error
          });

        case 9:
          _context3.next = 16;
          break;

        case 11:
          _context3.next = 13;
          return call(retrieveJwt);

        case 13:
          token = _context3.sent;
          _context3.next = 16;
          return put({
            type: 'SET_AUTHENTICATED',
            payload: {
              token: token,
              callback: callback
            }
          });

        case 16:
          _context3.next = 21;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](1);
          console.error(_context3.t0);

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[1, 18]]);
})));
var SYSTEM_TOKEN = 'kd-system';
regSaga(takeEvery('INITIALIZE', /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
  var _ref3$payload, system, socket, token, localToken, parsedToken, isValid, _yield$call4, securityStrategies, _yield$call4$session, csrfToken, isAuthenticated, spaceSlug, _token;

  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref3$payload = _ref3.payload, system = _ref3$payload.system, socket = _ref3$payload.socket;
          _context4.prev = 1;

          if (!system) {
            _context4.next = 9;
            break;
          }

          localToken = localStorage ? localStorage.getItem(SYSTEM_TOKEN) : null;

          if (localToken) {
            parsedToken = JSON.parse(atob(localToken.split('.')[1]));
            isValid = moment.unix(parsedToken.exp).isAfter(new Date());
            token = isValid ? localToken : null;
          }

          _context4.next = 7;
          return put(action('SET_INITIALIZED', {
            socket: socket,
            system: system,
            token: token
          }));

        case 7:
          _context4.next = 30;
          break;

        case 9:
          _context4.next = 11;
          return call(fetchSpaMeta);

        case 11:
          _yield$call4 = _context4.sent;
          securityStrategies = _yield$call4.securityStrategies;
          _yield$call4$session = _yield$call4.session;
          csrfToken = _yield$call4$session.csrfToken;
          isAuthenticated = _yield$call4$session.isAuthenticated;
          spaceSlug = _yield$call4.spaceSlug;

          if (!isAuthenticated) {
            _context4.next = 23;
            break;
          }

          _context4.next = 20;
          return call(retrieveJwt);

        case 20:
          _context4.t0 = _context4.sent;
          _context4.next = 24;
          break;

        case 23:
          _context4.t0 = null;

        case 24:
          _token = _context4.t0;

          if (!(socket && _token)) {
            _context4.next = 28;
            break;
          }

          _context4.next = 28;
          return call(socketIdentify, _token);

        case 28:
          _context4.next = 30;
          return put(action('SET_INITIALIZED', {
            csrfToken: csrfToken,
            securityStrategies: securityStrategies,
            socket: socket,
            spaceSlug: spaceSlug,
            token: _token
          }));

        case 30:
          _context4.next = 35;
          break;

        case 32:
          _context4.prev = 32;
          _context4.t1 = _context4["catch"](1);
          console.error(_context4.t1);

        case 35:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[1, 32]]);
})));
regSaga(takeEvery('LOGOUT_START', /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref4) {
  var payload, system, loggedIn;
  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _ref4.payload;
          _context5.prev = 1;
          _context5.next = 4;
          return select(function (state) {
            return state.getIn(['session', 'system']);
          });

        case 4:
          system = _context5.sent;
          _context5.next = 7;
          return select(function (state) {
            return state.getIn(['session', 'token']);
          });

        case 7:
          loggedIn = _context5.sent;

          if (!(!system && loggedIn)) {
            _context5.next = 11;
            break;
          }

          _context5.next = 11;
          return call(logoutDirect);

        case 11:
          _context5.next = 13;
          return put(action('LOGOUT'));

        case 13:
          if (!isFunction(payload)) {
            _context5.next = 16;
            break;
          }

          _context5.next = 16;
          return call(payload);

        case 16:
          _context5.next = 21;
          break;

        case 18:
          _context5.prev = 18;
          _context5.t0 = _context5["catch"](1);
          console.error(_context5.t0);

        case 21:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[1, 18]]);
})));
regSaga(takeEvery('SET_AUTHENTICATED', /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref5) {
  var payload, socket;
  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref5.payload;
          _context6.next = 3;
          return select(function (state) {
            return state.getIn(['session', 'socket']);
          });

        case 3:
          socket = _context6.sent;

          if (!socket) {
            _context6.next = 7;
            break;
          }

          _context6.next = 7;
          return call(socketIdentify, payload.token);

        case 7:
          if (!isFunction(payload.callback)) {
            _context6.next = 10;
            break;
          }

          _context6.next = 10;
          return call(payload.callback);

        case 10:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6);
})));

var onChangeUsername = function onChangeUsername(e) {
  dispatch('SET_USERNAME', e.target.value);
};

var onChangePassword = function onChangePassword(e) {
  dispatch('SET_PASSWORD', e.target.value);
};

var onLogin = function onLogin(e, callback) {
  e.preventDefault();
  dispatch('LOGIN', callback);
};

var logout = function logout(callback) {
  dispatch('LOGOUT_START', callback);
};

var timedOut = function timedOut() {
  dispatch('TIMEOUT');
};

var getToken = function getToken() {
  return store.getState().getIn(['session', 'token']);
};

export var AuthenticationComponent = /*#__PURE__*/function (_Component) {
  _inherits(AuthenticationComponent, _Component);

  var _super = _createSuper(AuthenticationComponent);

  function AuthenticationComponent() {
    _classCallCheck(this, AuthenticationComponent);

    return _super.apply(this, arguments);
  }

  _createClass(AuthenticationComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.system) {
        dispatch('INITIALIZE', {
          system: true,
          socket: false
        });
      } else {
        dispatch('INITIALIZE', {
          socket: !this.props.noSocket
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          initialized = _this$props.initialized,
          loggedIn = _this$props.loggedIn,
          login = _this$props.login,
          securityStrategies = _this$props.securityStrategies,
          spaceSlug = _this$props.spaceSlug,
          token = _this$props.token;
      return this.props.children({
        initialized: initialized,
        timedOut: loggedIn && !token,
        loggedIn: loggedIn,
        loginProps: _objectSpread({
          onChangeUsername: onChangeUsername,
          onChangePassword: onChangePassword,
          onLogin: onLogin,
          onSso: securityStrategies && securityStrategies.length > 0 ? function (callback) {
            return dispatch('SINGLE_SIGN_ON', {
              callback: callback,
              spaceSlug: spaceSlug
            });
          } : null
        }, login)
      });
    }
  }]);

  return AuthenticationComponent;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    initialized: state.getIn(['session', 'initialized'], false),
    loggedIn: state.getIn(['session', 'loggedIn'], false),
    token: state.getIn(['session', 'token'], null),
    login: state.get('login', defaultLoginProps),
    spaceSlug: state.getIn(['session', 'spaceSlug'], ''),
    securityStrategies: state.getIn(['session', 'securityStrategies'], [])
  };
};

var AuthenticationContainer = connect(mapStateToProps)(AuthenticationComponent);
export { AuthenticationContainer, getToken, logout, timedOut };